import { IContractFormikStatus } from 'services/templates/types';
import { contractTemplateFormInitialStatus } from '../form/contractTemplateFormInitialStatus';

export const contractTemplateInitialStatus: IContractFormikStatus = {
  ...contractTemplateFormInitialStatus,
};
